import { AbstractControlOptions, AsyncValidatorFn, FormGroup, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { TypedFormArray, TypedFormControl, ValuesOf } from '.';
import { DeepPartial, FormEventOptions, ResetValue } from './form-types';

/* eslint-disable max-len */

// export type FormGroupDeclaration = Record<string, TypedControl>;
export type FormGroupDeclaration = Record<string, TypedFormArray | TypedFormControl | TypedFormGroup>;
export type LooseFormGroupDeclaration = Record<string, any>;

/**
 * This is a strongly typed thin wrapper type around `FormGroup`.
 * Can be created using the `typedFormGroup` function
 */

export interface TypedFormGroup<LooseDeclaration extends LooseFormGroupDeclaration = LooseFormGroupDeclaration,
  Controls extends FormGroupDeclaration = MapFormGroupDeclaration<LooseDeclaration>,
  Value = ValuesOf<Controls>> extends FormGroup {
  controls: Controls;
  getRawValue: ()=> Value;
  patchValue: (v: DeepPartial<Value>, options?: FormEventOptions)=> void;
  reset: (value?: ResetValue<Value>, options?: FormEventOptions)=> void;
  setControl: <T extends keyof Controls>(name: T extends string ? T : never, control: Controls[T])=> void;
  setValue: (v: Value, options?: FormEventOptions)=> void;
  value: Value;
  valueChanges: Observable<Value>;
}

export function typedFormGroup<LooseDeclaration extends LooseFormGroupDeclaration = LooseFormGroupDeclaration,
  Controls extends FormGroupDeclaration = MapFormGroupDeclaration<LooseDeclaration>>(
  controls: Controls,
  validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
  asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
) {
  return <TypedFormGroup<LooseDeclaration, Controls>>
    new FormGroup(controls, validatorOrOpts, asyncValidator);
}

export type MapFormGroupDeclaration<T extends LooseFormGroupDeclaration> = {
  [Property in keyof T]: T[Property] extends TypedFormArray | TypedFormControl | TypedFormGroup ? T[Property] : TypedFormControl<T[Property]>;
};

